import { atom } from "recoil"

export const passwordCodeAtom = atom({
    key: "passwordCodeAtom",
    default: ""
})
export const passwordResetEmailAtom = atom({
    key: "passwordResetEmailAtom",
    default: ""
})
